import Header from "components/search/Header";

function Search() {
  return (
    <>
      <Header />
    </>
  );
}

export default Search;
